import { filter } from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  styled,
  Divider,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Backdrop,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Box,
  Select
} from '@material-ui/core';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker from '@material-ui/lab/DatePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import moment from 'moment';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import PrintIcon from '@material-ui/icons/Print';
import VisibilityIcon from '@material-ui/icons/Visibility';

import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import { baseUrl, currencies, npvLedgers } from '../../utils/constants';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

if (pdfjsLib && pdfjsWorker) {
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const TABLE_HEAD = [
  { id: 'department', label: 'Receipt #', alignRight: true },
  { id: 'tarrifCode', label: 'Date of Pmt', alignRight: true },
  { id: 'description', label: 'Paid By', alignRight: false },
  { id: 'service', label: 'Manual Rec #', alignRight: true },
  { id: 'count', label: 'Method', alignRight: false },
  { id: 'amount', label: 'Amount Paid', alignRight: true },
  { id: 'units', label: 'Revenue', alignRight: false },
  { id: 'amountPd', label: 'Stroke', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

const currenciesStr = [
  {
    value: 'USD',
    label: 'USD'
  },
  {
    value: 'ZiG',
    label: 'Zim Dollar'
  }
];

const loansClients = [
  {
    refId: 1,
    name: 'Active Loans'
  },
  {
    refId: 2,
    name: 'Active Clients'
  }
];

export default function DateRangeReport() {
  const { id } = useParams();
  const m = moment();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [begDate, setBegDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docType, setDocType] = useState('xls');
  const [param, setParam] = useState(0);
  const [orderBy, setOrderBy] = useState('documentType');
  const [showDate, setShowDate] = useState(true);
  const [showEndDate, setShowEndDate] = useState(true);
  const [showParam, setShowParam] = useState(false);
  const [showCurrency, setShowCurrency] = useState(false);
  const [showLedger, setShowLedger] = useState(false);
  const [ledger, setLedger] = useState('Interest');
  const [reportType, setReportType] = useState(0);
  const [currency, setCurrency] = useState('USD');
  const [showCurrencyRef, setShowCurrencyRef] = useState(false);
  const [currencyRef, setCurrencyRef] = useState(3);
  const [iframeSrc, setIframeSrc] = useState('');
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(14);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const filename = `${id}_${moment().format('DD-MMM-YYYY')}.${docType}`;
  const navigate = useNavigate();
  console.log('begDate in useEffect 123', begDate);

  useEffect(() => {
    if (id === 'LoanShedule') {
      setShowDate(false);
      setShowParam(true);
    }
    if (id === 'MonthlyNPV') {
      setShowCurrency(true);
    }
    if (id === 'ActiveLoans') {
      setReportType(1);
    }
    if (id === 'ActiveClients') {
      setReportType(2);
    }
    if (
      id === 'EIRReport' ||
      id === 'CollectionsVintageSummary' ||
      id === 'CollectionsVintageByLoan' ||
      id === 'MonthlyNpvByLedger'
    ) {
      setShowCurrencyRef(true);
    }
    if (
      id === 'AccruedIncomeReport' ||
      id === 'NonPayments' ||
      id === 'Ageing' ||
      id === 'EIRReport' ||
      id === 'MonthlyNPV' ||
      id === 'ActualvsExpected' ||
      id === 'CollectionsEfficiencySummaryReport' ||
      id === 'CollectionsEfficiencySummaryReportNEW' ||
      id === 'ActiveLoans' ||
      id === 'ActiveClients'
    ) {
      setShowDate(false);
    }
    if (
      id === 'SalesReports' ||
      id === 'FullBookStatus' ||
      id === 'MonthlyAnalysisPARReport' ||
      id === 'BookRundown' ||
      id === 'ProductMixReport' ||
      id === 'PaymentReport' ||
      id === 'CollectionsVintageSummary' ||
      id === 'CollectionsVintageByLoan' ||
      id === 'ActiveLoans' ||
      id === 'ActiveClients' ||
      id === 'MonthlyNpvByLedger'
    ) {
      setShowDate(false);
      setShowEndDate(false);
    }
    if (id === 'MonthlyNpvByLedger') {
      setShowLedger(true);
      setShowEndDate(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  const downloadDocument = () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/warehouse/get/${id}/${docType}/${moment(begDate).format(
        'YYYY-MM-DD'
      )}/${moment(endDate).format(
        'YYYY-MM-DD'
      )}/${currency}/0/${reportType}/${param}/${currencyRef}/${ledger}`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Reports Creation!: ${error}`, 'error');
        }
      );
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const handlePrintPreview = async () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/warehouse/get/${id}/pdf/${moment(begDate).format('YYYY-MM-DD')}/${moment(
        endDate
      ).format('YYYY-MM-DD')}/${currency}/0/${reportType}/${param}/${currencyRef}/${ledger}`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const fileURL = URL.createObjectURL(new Blob([blob]));
          setIframeSrc(fileURL);
          setOpenPreviewDialog(true);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Ledger Period Report!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2} m={2}>
        <Grid item xs={5} sm={4}>
          <Typography component="span" variant="h4" gutterBottom>
            {`Management Reports - ${id}`}
          </Typography>
        </Grid>
        {showParam && (
          <Grid item xs={12} sm={1}>
            <FormControl fullWidth>
              <TextField
                value={param}
                onChange={(e) => {
                  setParam(e.target.value);
                }}
                color="primary"
                label="Loan RefId"
                placeholder="Loan RefId"
                size="small"
                variant="standard"
              />
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12} sm={1}>
          <FormControl>
            <InputLabel id="selectDoc">Doc Type</InputLabel>
            <Select
              labelId="selectDoclabel"
              id="docType"
              size="small"
              value={docType}
              onChange={(e) => {
                setDocType(e.target.value);
              }}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="xls">XLS</MenuItem>
              <MenuItem value="doc">WORD</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {showDate && (
          <Grid item xs={12} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Start Date"
                inputFormat="dd/MM/yyyy"
                value={begDate}
                onChange={(e) => {
                  setBegDate(e);
                }}
                renderInput={(params) => <TextField {...params} fullWidth size="small" />}
              />
            </LocalizationProvider>
          </Grid>
        )}
        {showEndDate && (
          <Grid item xs={12} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="End Date"
                inputFormat="dd/MM/yyyy"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e);
                }}
                renderInput={(params) => <TextField {...params} fullWidth size="small" />}
              />
            </LocalizationProvider>
          </Grid>
        )}
        {showCurrency && (
          <Grid item xs={12} sm={1}>
            <FormControl fullWidth>
              <TextField
                id="standard-select-currency"
                // style={{ width: 180, height: 30, pb: 2 }}
                select
                size="small"
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
              >
                <MenuItem key="" value="0">
                  Select Currency
                </MenuItem>
                {currenciesStr.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
        )}
        {showCurrencyRef && (
          <Grid item xs={12} sm={1}>
            <FormControl>
              <TextField
                id="standard-select-currencref"
                // style={{ width: 180, height: 30, pb: 2 }}
                select
                size="small"
                value={currencyRef}
                onChange={(e) => setCurrencyRef(e.target.value)}
              >
                <MenuItem key="" value="0">
                  Select Currency
                </MenuItem>
                {currencies.map((option) => (
                  <MenuItem key={option.refId} value={option.refId}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
        )}
        {showLedger && (
          <Grid item xs={12} sm={2}>
            <FormControl fullWidth>
              <TextField
                id="standard-select-currencref"
                // style={{ width: 180, height: 30, pb: 2 }}
                select
                size="small"
                value={ledger}
                onChange={(e) => setLedger(e.target.value)}
              >
                <MenuItem key="" value="0">
                  Select Account
                </MenuItem>
                {npvLedgers.map((option) => (
                  <MenuItem key={option.refId} value={option.refId}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
        )}

        <Grid item xs={12} sm={1}>
          {/* <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => getExtraPayments()}
          >
            Refresh
          </Button> */}
        </Grid>
        <Grid item xs={12} sm={1} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<VisibilityIcon />}
            onClick={handlePrintPreview}
          >
            Preview
          </Button>
        </Grid>
        <Grid item xs={12} sm={1} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => downloadDocument()}
          >
            Export
          </Button>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, margin: 10 }} variant="middle" />

      <Card>
        {/* <Scrollbar> */}
        <TableContainer sx={{ minWidth: 800 }}>
          <Table size="small" aria-label="a dense table">
            <ClientListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {filteredUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  /* eslint-disable camelcase */
                  const {
                    receiptNumber,
                    paymentDate,
                    memberName,
                    manualReceipt,
                    paymentMethod,
                    amountPaid,
                    revenue,
                    cycle
                  } = row;
                  const isItemSelected = selected.indexOf(receiptNumber) !== -1;

                  return (
                    <StyledTableRow
                      hover
                      key={receiptNumber}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell padding="checkbox" />

                      <TableCell align="right">{receiptNumber}</TableCell>
                      <TableCell align="right">
                        {moment(paymentDate).isValid()
                          ? moment(paymentDate).format('YYYY-MM-DD')
                          : ''}
                      </TableCell>
                      <TableCell align="left">{memberName}</TableCell>
                      <TableCell align="right">{manualReceipt}</TableCell>
                      <TableCell align="left">{paymentMethod}</TableCell>
                      <TableCell align="right">{amountPaid.toFixed(2)}</TableCell>
                      <TableCell align="left">{revenue}</TableCell>
                      <TableCell align="left">
                        {' '}
                        {moment(cycle).isValid() ? moment(cycle).format('MMM-YYYY') : ''}
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isListEmpty && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
        {/* </Scrollbar> */}

        <TablePagination
          sx={{
            backgroundColor: 'black',
            color: 'white',
            size: 'small'
          }}
          rowsPerPageOptions={[14, 28, 42]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      <Dialog open={openPreviewDialog} onClose={() => setOpenPreviewDialog(false)} fullScreen>
        <DialogTitle>Payroll Report - Print Preview</DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          {iframeSrc ? (
            <Worker>
              <div style={{ height: '100vh', width: '100%' }}>
                <Viewer fileUrl={iframeSrc} plugins={[defaultLayoutPluginInstance]} />
              </div>
            </Worker>
          ) : (
            <Box sx={{ textAlign: 'center', padding: 4 }}>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handlePrint} color="secondary" startIcon={<PrintIcon />}>
            Print
          </Button> */}
          <Button size="large" onClick={() => setOpenPreviewDialog(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
